import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold mb-4">古风漫画网</h3>
            <p className="text-sm text-background-50/70 leading-relaxed">
              专注于提供免费韩国漫画在线阅读服务，以古风美学为设计理念，为您带来流畅舒适的下拉式阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">&nbsp;</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  用户口碑
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  联系方式
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; {new Date().getFullYear()} 古风漫画网 - 免费韩国漫画在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}